// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2cYCW","fileBtn":"File_fileBtn__2p5Ns","closeBtn":"File_closeBtn__2uYxa","fileSelected":"File_fileSelected__2dSgc","disabled":"File_disabled__akup6"};